exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vrm-box[data-v-5548deee]{min-width:106px;max-width:135px;flex-grow:1;text-align:center}@media (max-width:1024px){.vehicle-description-width[data-v-5548deee]{max-width:303px}}", ""]);

// exports
